import { convertTable } from '@loaders.gl/schema';
import * as arrow from 'apache-arrow';
import { convertArrowToColumnarTable } from "../tables/convert-arrow-to-columnar-table.js";
import { serializeArrowSchema } from "../schema/convert-arrow-schema.js";
export function parseArrowSync(arrayBuffer, options) {
  const apacheArrowTable = arrow.tableFromIPC([new Uint8Array(arrayBuffer)]);
  const arrowTable = {
    shape: 'arrow-table',
    schema: serializeArrowSchema(apacheArrowTable.schema),
    data: apacheArrowTable
  };
  const shape = (options === null || options === void 0 ? void 0 : options.shape) || 'arrow-table';
  switch (shape) {
    case 'arrow-table':
      return arrowTable;
    case 'columnar-table':
      return convertArrowToColumnarTable(arrowTable);
    case 'object-row-table':
      let columnarTable = convertArrowToColumnarTable(arrowTable);
      return convertTable(columnarTable, 'object-row-table');
    case 'array-row-table':
      columnarTable = convertArrowToColumnarTable(arrowTable);
      return convertTable(columnarTable, 'array-row-table');
    default:
      throw new Error(shape);
  }
}
//# sourceMappingURL=parse-arrow-sync.js.map